import React, { useContext } from "react";
import { fee } from "../../rbac-consts";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { default as AdminFeeDetailsContainer } from "./admin/FeeDetailsContainer";

const FeeDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={fee.ADMIN}
      yes={() => (
        <AdminFeeDetailsContainer match={match} />
      )}
    />
  );
};

export default FeeDetailsWrapper;